export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Confronto
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Itaobuy Spreadsheet vs Ricerca Tradizionale
          </h2>
        </div>

        <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-5 px-6 md:px-8 text-foreground-700 font-semibold text-sm">Caratteristica</th>
                <th className="text-center py-5 px-6 md:px-8 text-primary-600 font-semibold text-sm">
                  <i className="ri-checkbox-circle-fill mr-1.5"></i>
                  Itaobuy Spreadsheet
                </th>
                <th className="text-center py-5 px-6 md:px-8 text-foreground-400 font-semibold text-sm">
                  Ricerca tradizionale
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Prodotti organizzati', sheet: true, trad: false },
                { feature: 'Risparmio tempo', sheet: 'Alto', trad: 'Basso' },
                { feature: 'Filtri prodotti', sheet: true, trad: 'Limitati' },
                { feature: 'Guide disponibili', sheet: true, trad: false },
                { feature: 'Analisi qualita', sheet: 'Possibile', trad: 'Difficile' },
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-background-100 last:border-0">
                  <td className="py-4 px-6 md:px-8 text-foreground-700 text-sm">{row.feature}</td>
                  <td className="py-4 px-6 md:px-8 text-center">
                    {typeof row.sheet === 'boolean' ? (
                      row.sheet ? (
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-accent-100">
                          <i className="ri-check-line text-accent-600 text-sm"></i>
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-background-100">
                          <i className="ri-close-line text-foreground-300 text-sm"></i>
                        </span>
                      )
                    ) : (
                      <span className="text-foreground-700 text-sm font-medium">{row.sheet}</span>
                    )}
                  </td>
                  <td className="py-4 px-6 md:px-8 text-center">
                    {typeof row.trad === 'boolean' ? (
                      row.trad ? (
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-accent-100">
                          <i className="ri-check-line text-accent-600 text-sm"></i>
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-background-100">
                          <i className="ri-close-line text-foreground-300 text-sm"></i>
                        </span>
                      )
                    ) : (
                      <span className="text-foreground-400 text-sm">{row.trad}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}